var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6",
      "sm": "6"
    }
  }, [_c('statistic-card-horizontal', {
    attrs: {
      "icon": "BarChart2Icon",
      "color": "primary",
      "statistic": _vm.cardSales,
      "statistic-title": "Rank Sales"
    },
    on: {
      "onClick": function onClick($event) {
        return _vm.$router.push('/rank-sales');
      }
    }
  })], 1), _c('b-col', {
    attrs: {
      "lg": "6",
      "sm": "6"
    }
  }, [_c('statistic-card-horizontal', {
    attrs: {
      "icon": "UsersIcon",
      "color": "success",
      "statistic": _vm.cardKaryawan,
      "statistic-title": "Total Karyawan"
    },
    on: {
      "onClick": function onClick($event) {
        return _vm.$router.push('/karyawan');
      }
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }